import styled from 'styled-components'
import { Tooltip } from 'react-tooltip'
import { Box } from '../../UI/Box'
import { IPool } from '../../../types/reducerTypes'

import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'
import { isEmpty, isNil } from 'ramda'
import { Badge } from '../PoolBadges'

export const AuditGroup = styled(Box)`
  text {
    font-weight: 700;
  }
`

export const AuditText = styled.span`
  color: #fff;
  font-feature-settings: 'ss01' on;
  font-family: 'Space Grotesk';
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  text-transform: uppercase;
`

const getScoreColor = (totalScore: number) => {
  if (totalScore < 20) {
    return '#e32f30'
  }
  if (totalScore < 40) {
    return '#f18230'
  }
  if (totalScore < 60) {
    return '#ffd334'
  }
  if (totalScore < 80) {
    return '#80c12a'
  }
  return '#1ce648'
}

function PoolAutomatedAudit({ audit }: Pick<IPool, 'audit'>) {
  if (!audit || isEmpty(audit)) return null

  const { automatedAudit } = audit
  const { rank, securityScore, address } = automatedAudit ?? {}

  if (
    isNil(securityScore) ||
    Number.isNaN(securityScore) ||
    securityScore === 0
  )
    return null

  const fixedScore = Math.round(securityScore)
  const color = getScoreColor(fixedScore)

  return (
    <AuditGroup ac g={8} fu aw>
      <Box mw="42px">
        <CircularProgressbar
          value={fixedScore}
          text={`${fixedScore}%`}
          styles={buildStyles({
            // Rotation of path and trail, in number of turns (0-1)
            rotation: 0,

            // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
            strokeLinecap: 'round',

            // Text size
            textSize: '22px',

            // How long animation takes to go from one percentage to another, in seconds
            pathTransitionDuration: 0.5,

            // Can specify path transition in more detail, or remove it entirely
            // pathTransition: 'none',

            // Colors
            pathColor: color,
            textColor: '#FFF',
            trailColor: 'rgba(255, 255, 255, 0.3)',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
          })}
        />
      </Box>
      <AuditText>
        <a
          href={`https://www.cyberscope.io/cyberscan?network=BLAST&address=${address}`}
        >
          <Box ac>
            {rank}
            <img
              src="/img/icons/diluted-info.svg"
              style={{ marginLeft: 4 }}
              alt="Audit score icon"
              data-tooltip-id="audit-score-tooltip"
            />
            <Tooltip id="audit-score-tooltip">
              <span>
                Cyberscan audit security score. Click for full report.
              </span>
            </Tooltip>
          </Box>
        </a>
      </AuditText>
    </AuditGroup>
  )
}

export default PoolAutomatedAudit
